import { ProcessDocumentToMerge } from 'domain/usecases/surgical-order/process-document-to-merge'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteProcessDocumentToMerge implements ProcessDocumentToMerge {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  process(
    params: ProcessDocumentToMerge.Params
  ): Promise<ProcessDocumentToMerge.Model> {
    return this.surgicalOrderRepository.processDocumentToMerge(params)
  }
}
